export default {
  phone: 'Phone',
  booth: 'Booth',
  viewer: 'Spectator',
  customer: 'Service',
  online_customer: 'Online customer',
  my: 'My',
  vote: 'Ticket',
  cooperate: 'Booth'
}
